import React, { useEffect, useRef } from 'react';

const YouTubePlayer = ({ videoId, onReady }) => {
    const playerRef = useRef(null);

    useEffect(() => {
        const initializePlayer = () => {
            if (window.YT && window.YT.Player) {
                playerRef.current = new window.YT.Player('youtube-player', {
                    videoId,
                    playerVars: {
                        autoplay: 1, // Autoplay video
                        controls: 1, // Hide controls
                        rel: 0, // Do not show related videos
                        modestbranding: 1, 
                    },
                    events: {
                        onReady: (event) => {
                            event.target.playVideo();
                            if (onReady) onReady(event);
                        },
                    },
                });
            } else {
                console.error('YouTube IFrame API is not available.');
            }
        };

        const loadYouTubeAPI = () => {
            if (!window.YT) {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.async = true;
                document.body.appendChild(script);
                script.onload = () => {
                    if (window.YT && window.YT.Player) {
                        initializePlayer();
                    } else {
                        window.onYouTubeIframeAPIReady = initializePlayer;
                    }
                };
            } else {
                initializePlayer();
            }
        };

        loadYouTubeAPI();

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
            }
        };
    }, [videoId, onReady]);

    return <div id="youtube-player" style={{ width: '100%', height: '100%' }}></div>;
};

export default YouTubePlayer;
